import { useSyncExternalStore } from "react";
const subscribeToNothing = () => () => {};
const getIsMac = () => /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);
const getServerIsMac = () => true;

/**
 * Whether to label shortcuts with ⌘/⌥ (Apple) or Ctrl/Alt. Assumes Mac for
 * SSR and the hydration render; the first client render reads `navigator`.
 */
export function useIsMac() {
  return useSyncExternalStore(subscribeToNothing, getIsMac, getServerIsMac);
}